import { Outlet, useRouterState } from "@tanstack/react-router";
import { BottomNav } from "@/components/bottom-nav";
import { EmailVerificationBanner } from "@/components/email-verification-banner";
import { Footer } from "@/components/footer";
import Header from "@/components/header";
import { ListsProvider } from "@/contexts/lists-provider";

// Router-level `defaultErrorComponent` (see `router.tsx`) renders `AppError`
// for any boundary that doesn't override — including this layout — so no
// explicit `errorComponent` here.

function shouldShowEmailVerificationBanner(pathname: string) {
  return pathname !== "/taste";
}

// No nested IntlProvider here: the root route ships the full message tree,
// so `useTranslations` inside Header/Footer/BottomNav/ListsProvider resolves
// against the root. An intermediate scoped provider (as in the original
// Next.js port) stripped namespaces from child routes — e.g. the `artist`
// bucket disappearing from `useMessages()` in `_app/artist/$id`'s scope
// picker — without saving any bundle size, since the root already has
// everything.
function AppLayout() {
  const pathname = useRouterState({
    select: state => state.location.pathname
  });
  const isAdminRoute = pathname.startsWith("/admin");
  const isAuthRoute = pathname === "/login" || pathname === "/forgot-password" || pathname === "/reset-password";
  const showEmailVerificationBanner = shouldShowEmailVerificationBanner(pathname);
  if (isAdminRoute) {
    return <ListsProvider>
        <Outlet />
      </ListsProvider>;
  }
  return <ListsProvider>
      <div className="flex min-h-dvh flex-col">
        <Header showSearch={!isAuthRoute} />
        {showEmailVerificationBanner && <EmailVerificationBanner />}
        <main className="flex-1 pb-[calc(3.5rem+env(safe-area-inset-bottom))] xl:pb-0">
          <Outlet />
        </main>
        <Footer />
        <BottomNav />
      </div>
    </ListsProvider>;
}
export { AppLayout as component };